import cn from "classnames";
import "./ListLinksLargeBlock.scss";
import GridRow from "/Components/Layout/GridRow/GridRow";
import {
  ArrowLineUpRightIcon,
  ArrowRightIcon,
  GridPresetOneHalf,
  Link,
  OptimizelyEditProperty,
} from "/App.Components";
import { ListLinksLargeBlockProps } from "/Models/Generated/ListLinksLargeBlockProps";
import { NoradTheme } from "/Models/Generated/NoradTheme";
import { LinkProps } from "/Models/Generated/LinkProps";
import { ColorTheme } from "/Models/Models/ColorTheme";

const ListLinksLargeBlock = ({
  heading,
  headingPropertyName,
  introText,
  introTextPropertyName,
  linkList,
  linkListPropertyName,
  theme,
}: ListLinksLargeBlockProps) => {
  return (
    <article
      className={cn("list-links-large-block-norad", {
        "list-links-large-block-norad--secondary":
          theme === NoradTheme.Secondary,
      })}
    >
      <GridRow>
        <GridPresetOneHalf>
          <OptimizelyEditProperty propertyName={headingPropertyName}>
            {heading && (
              <h2 className="list-links-large-block-norad__heading">
                {heading}
              </h2>
            )}
          </OptimizelyEditProperty>
          <OptimizelyEditProperty propertyName={introTextPropertyName}>
            {introText && (
              <p className="list-links-large-block-norad__intro">{introText}</p>
            )}
          </OptimizelyEditProperty>
        </GridPresetOneHalf>
        <GridPresetOneHalf>
          <OptimizelyEditProperty propertyName={linkListPropertyName}>
            {(linkList?.length ?? 0) > 0 && (
              <ul className="list-links-large-block-norad__links">
                {(linkList as LinkProps[]).map((link, idx) => (
                  <li key={idx} className="list-links-large-block-norad__link">
                    <Link
                      {...link}
                      iconPlacement="before"
                      colorTheme={ColorTheme.default}
                      icon={
                        link.isExternal ? ArrowLineUpRightIcon : ArrowRightIcon
                      }
                      breakWord
                    />
                  </li>
                ))}
              </ul>
            )}
          </OptimizelyEditProperty>
        </GridPresetOneHalf>
      </GridRow>
    </article>
  );
};

export default ListLinksLargeBlock;
